module.exports = __webpack_public_path__ + "static/media/ShawnaChatfield-resume.c6297e85.pdf";